import React, { useMemo } from "react";
import NumberFormatter from "components/common/NumberFormatter/NumberFormatter";
import PieChart from "../components/PieChart";

const BudgetStats = (props) => {
  const { funding, isSupportCoordination } = props;
  const core= funding?.total_budget_stats[0]?.core;
  const capital= funding?.total_budget_stats[1]?.capital;
  const capacityCapital= funding?.total_budget_stats[2]["capacity building"];

  const loadStats = useMemo(() => {
    if (!funding) return "";

    const stats = [
      {
        name: "Total Funding",
        stat: `$${funding.total_contract_amount ?? 0}`,
        color: "#32D583",
      },
      {
        name: "Total Allocated",
        stat: `$${funding.amount_allocated ?? 0}`,
        color: "#F38744",
      },
      {
        name: "Total Delivered",
        stat: `$${funding.amount_delivered ?? 0}`,
        color: "#53B1FD",
      },
      {
        name: "Total Remaining",
        stat: `$${Math.max(0, parseFloat(funding.amount_remaining ?? 0)).toFixed(2)}`,
        color: "#F87171",
      },
    ];

 

    const stats_for_rostering = [
      // {
      //   name: "Core",
      //   stat: (
      //     <PieChart
      //       totalFunding={core?.total_budget_amount}
      //       totalAllocated={core?.amount_allocated}
      //       totalRemaining={core?.amount_remaining}
      //     />
      //   ),
      //   color: "#dd43",
      // },
      // {
      //   name: "Capacity Building",
      //   stat: (
      //     <PieChart
      //     totalFunding={capacityCapital?.total_budget_amount}
      //       totalAllocated={capacityCapital?.amount_allocated}
      //       totalRemaining={capacityCapital?.amount_remaining}
      //     />
      //   ),
      //   color: "#F384",
      // },
      // {
      //   name: "Capital",
      //   stat: (
      //     <PieChart
      //     totalFunding={capital?.total_budget_amount}
      //     totalAllocated={capital?.amount_allocated}
      //     totalRemaining={capital?.amount_remaining}
      //     />
      //   ),
      //   color: "#53B1",
      // },
      // {
      //   name: "Total Remaining",
      //   stat: `$${funding.amount_remaining ?? 0}`,
      //   color: "#F871",
      // },
    ];

    // If isSupportCoordination is true, show both sets of stats, otherwise show only stats
    const combinedStats = isSupportCoordination ? [...stats, ...stats_for_rostering] : stats;

    return combinedStats.map((item, index) => (
      <div
        key={index}
        style={{ borderLeft: `4px solid ${item.color}` }}
        className="grid-span-1 overflow-hidden rounded-lg py-5 pl-4 bg-white border transition ease-in-out duration-150 hover:shadow-lg"
      >
        <dt className="truncate text-sm font-bold text-gray-500">{item.name}</dt>
        <dd>
          {typeof item.stat === "string" ? (
            <NumberFormatter
              cssClass="mt-1 text-2xl font-semibold tracking-tight text-gray-900"
              prefix="$"
              value={item.stat.replace("$", "")}
            />
          ) : (
            <section>{item.stat}</section>
          )}
        </dd>
      </div>
    ));
  }, [funding, isSupportCoordination]);

  return (
    <div>
      <div className="min-h-full">
        <div className="py-4 max-w-3xl mx-auto sm:px-8 lg:max-w-7xl">
          <dl className="grid lg:grid-cols-2 gap-2 sm:grid-cols-1">{loadStats}</dl>
        </div>
      </div>
    </div>
  );
};

export default BudgetStats;
